/** Match a concrete URL against the registry's parameterised paths. */
import { ROUTES } from "./registry.js";
function toRegex(path) {
    const escaped = path.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const withParams = escaped.replace(/:[A-Za-z0-9_]+/g, "[^/]+");
    return new RegExp(`^${withParams}/?$`);
}
const CACHE = new Map();
/** Most-specific match wins (fewest parameter segments, then longest path). */
export function matchSpec(pathname) {
    let best = null;
    let bestScore = -1;
    for (const r of ROUTES) {
        let re = CACHE.get(r.path);
        if (!re) {
            re = toRegex(r.path);
            CACHE.set(r.path, re);
        }
        if (!re.test(pathname))
            continue;
        const params = (r.path.match(/:[A-Za-z0-9_]+/g) ?? []).length;
        const score = r.path.length - params * 5;
        if (score > bestScore) {
            best = r;
            bestScore = score;
        }
    }
    return best;
}
